import React from "react";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import Button from "../../../../../../../ui/Button";
import TextField from "@material-ui/core/TextField";

const DialogTitle = withStyles(theme => ({
  root: {
    color: "#778899",
    "& > h2": {
      fontSize: 12
    }
  }
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

export default function ProgramDialog({
  showProgramDialog,
  closeProgramDialog,
  addModuleVolume,
  volume,
  changeVolume,
  type,
  updateModuleVolume,
  title
}) {
  const addVolume = () => {
    const moduleVolume = {
      main: {
        number: volume.number,
        name: volume.name
      }
    };
    addModuleVolume(moduleVolume);
    closeProgramDialog();
  };

  const updateVolume = () => {
    const moduleVolume = {
      main: {
        number: volume.number,
        name: volume.name
      }
    };
    updateModuleVolume(volume.id, moduleVolume);
    closeProgramDialog();
  };

  return (
    <div>
      <Dialog open={showProgramDialog}>
        <div>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Grid container justify="space-between">
              <Grid item xs={2}>
                <TextField
                  name="number"
                  required
                  label="Номер"
                  value={volume && volume.number}
                  onChange={changeVolume}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="name"
                  required
                  label="Наименование"
                  value={volume && volume.name}
                  onChange={changeVolume}
                  InputLabelProps={{
                    shrink: true
                  }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={closeProgramDialog}>Отмена</Button>
            <Button
              onClick={() => (type === "add" ? addVolume() : updateVolume())}
              color="green"
            >
              {type === "add" ? "Добавить" : "Обновить"}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}
